export default "__VITE_ASSET__0212e5f8__"